/** 动态渲染编辑器名称 */
const DYNAMIC_RENDER_EDITOR = 'dynamic-render-editor';

export { DYNAMIC_RENDER_EDITOR };
